(function () {
    var JustifyReasonModalCtrl = /** @class */ (function () {
        function JustifyReasonModalCtrl($scope,            
            $mdDialog,            
            $q,            
            AuthService,
            $mdPanel,
            kmPerDay,
            $timeout,
            $mdToast,
            $translationService) {

            this.$scope = $scope;
            this.$mdDialog = $mdDialog;
            this.$q = $q;
            this.AuthService = AuthService;
            this.$mdPanel = $mdPanel;
            this.kmPerDay = kmPerDay;
            this.$timeout = $timeout;
            this.$mdToast = $mdToast;
            this.$translationService = $translationService;

            this.client = null;
           
            this.title = '';
            this.canSelectClient = false;
            this.selectClientPanel = null;

            this.selectedReason = 'personal';
            this.personalReason = '';

            this.onInit();
        }
      
        JustifyReasonModalCtrl.prototype.onInit = function () {            
            // this.title = `Please justify your charge request exceeding your estimated autonomy need of ${this.kmPerDay} km per day:`;

            this.title = this.$translationService.getTranslation('PlsJustifyChargeRequestExceedingAutonomyNeed').replace('{0}', this.kmPerDay);
            var license = sessionStorage.getItem('licenseType');
            this.canSelectClient = license == 'Manage';
            
            this.$scope.$on('$destroy', ()=>{
                if(this.MdPanelRef){
                    this.MdPanelRef.close();
                }
            })
        };

        JustifyReasonModalCtrl.prototype.onBtnOkClicked = function () {
            if (this.selectedReason === 'personal' && (this.personalReason || '').trim().length === 0) {
                var toast = this.$mdToast.simple()
                    .textContent(this.$translationService.getTranslation('PlsInputPersonalReason'))                    
                    .hideDelay(4000);
                this.$mdToast.show(toast);
                return false;
            }

            this.$mdDialog.hide({
                reason: this.selectedReason,
                personalReason: this.personalReason,
                client: this.client
            });
        };
        JustifyReasonModalCtrl.prototype.onBtnCancelClicked = function () {
            this.$mdDialog.cancel();
        };

        JustifyReasonModalCtrl.prototype.onShowClientsModal = function ($event) {
            $event.stopImmediatePropagation();
            this.$timeout(angular.bind(this, function () {
                this.showClientsModal({
                    $event: $event,
                    client: this.client
                });
            }), 100);
        }

        JustifyReasonModalCtrl.prototype.showClientsModal = function (options) {
            var _this = this;

            var config = {
                attachTo: angular.element(document.body),
                controller: 'ClientSelectorV2Ctrl',
                templateUrl: 'js/shared/clientsselector-v2/clientsselector.view.html',
                // controllerAs: 'vm',
                targetEvent: options.$event,
                clickOutsideToClose: true,
                escapeToClose: false,
                focusOnOpen: true,
                hasBackdrop: true,
                zIndex: 90,
                panelClass: 'client-selector-panel',
                locals: {
                    client: options.client,
                    options: {
                        optional: true,
                        selectOnly: true
                    }
                },
                onDomAdded: function ($scope) {
                    $(".client-selector-panel").parent().addClass("client-selector-panel-container");
                },
                onDomRemoved : function () {
                    // console.log('DOM removed ', _this.selectClientPanel);
                    // console.log('selected ', _this.selectClientPanel._config.scope.selectedClient);

                    if (_this.selectClientPanel && 
                        _this.selectClientPanel._config ) {
                        _this.client = _this.selectClientPanel._config.scope.selectedClient;
                    }

                    _this.selectClientPanel.destroy();
                    _this.selectClientPanel = null;
                }
            };
            
            this.MdPanelRef = this.$mdPanel.create(config);
            
            this.MdPanelRef.open().then(function (panel) {
                 _this.selectClientPanel = panel;
                 // need to init event for the panel
                 _this.selectClientPanel._config.scope.vm.ready();
            });
            
        };
        JustifyReasonModalCtrl.$inject = ['$scope',
            '$mdDialog',
            '$q',
            'AuthService',
            '$mdPanel',
            'kmPerDay',
            '$timeout',
            '$mdToast',
            '$translationService'];
        return JustifyReasonModalCtrl;
    }());
    angular.module('shared.justifyReasonModalCtrl', []).controller('JustifyReasonModalCtrl', JustifyReasonModalCtrl);
})();
